import { gsap, Linear, Power2 } from "gsap";

export default class Accordion extends HTMLElement {

	constructor(options) {

		super();

		const defaults = {
			closeSiblings: true
		}

		const populatedDefaults = Object.assign(defaults, options);
		for (const key in populatedDefaults) {
			if (Object.prototype.hasOwnProperty.call(populatedDefaults, key)) {
				this[key] = populatedDefaults[key];
			}
		}


		// Store all relevant DOM nodes of Component
		this.accordionTab = this.querySelector("details");
		this.summary = this.accordionTab.querySelector("summary");
		this.drawer = this.accordionTab.querySelector("details > div");
		this.expandIcon = this.accordionTab.querySelector("expand-icon")

		this.openText = this.summary.innerText
		this.closeText = this.dataset.closetext

		// Store if the element is closing
		this.isClosing = false;
		// Store if the element is expanding
		this.isExpanding = false;

		// Store the animation object (so we can cancel it if needed)
		this.timeline = gsap.timeline();

		this.summary.addEventListener("click", (e) => this.onClick(e));
	}

	onClick(e) {
		// Stop default behaviour from the browser
		e.preventDefault();
		// Add an overflow on the <details> to avoid content overflowing
		this.accordionTab.style.overflow = 'hidden';
		// Check if the element is being closed or is already closed
		if (this.isClosing || !this.accordionTab.open) {
			this.open();
			// Check if the element is being openned or is already open
		} else if (this.isExpanding || this.accordionTab.open) {
			this.shrink();
		}
	}

	open() {
		// Apply a fixed height on the element
		this.accordionTab.style.height = `${this.accordionTab.offsetHeight}px`;
		// Force the [open] attribute on the details element
		this.accordionTab.open = true;
		// Wait for the next frame to call the expand function
		window.requestAnimationFrame(() => this.expand());
	}

	shrink() {
		// Set the element as "being closed"
		this.isClosing = true;

		// Calculate the height of the summary
		const endHeight = `${this.summary.offsetHeight}px`;

		// If there is already an animation running
		if (this.timeline.isActive()) {
			// Cancel the current animation
			this.timeline.pause();
		}

		this.timeline.to(this.accordionTab,
			{
				height: endHeight,
				duration: 0.3,
				ease: "Power2.inOut",
				onComplete: () => this.onAnimationFinish(false),
				onInterrupt: () => this.isClosing = false
			}
		)

		if (this.expandIcon) this.expandIcon.shrink()
	}

	expand() {

		// Set the element as "being expanding"
		this.isExpanding = true;

		// If there is already an animation running
		if (this.timeline.isActive()) {
			// Cancel the current animation
			this.timeline.pause();
		}
		// Calculate the open height of the element (summary height + content height)
		const endHeight = `${this.summary.offsetHeight + this.drawer.offsetHeight}px`;

		this.timeline.to(this.accordionTab, {
			height: endHeight,
			duration: 0.3,
			ease: "Power2.inOut",
			onComplete: () => this.onAnimationFinish(true),
			onInterrupt: () => this.isExpanding = false
		})

		if (this.expandIcon) this.expandIcon.expand()

		if (this.closeSiblings) this.closeOthers()

	}

	onAnimationFinish(open) {
		// Set the open attribute based on the parameter
		this.accordionTab.open = open;
		if (open && this.closeText) {
			this.summary.innerText = this.closeText
		} else if (!open && this.closeText) {
			this.summary.innerText = this.openText
		}

		// Reset isClosing & isExpanding
		this.isClosing = false;
		this.isExpanding = false;
		// Remove the overflow hidden and the fixed height
		this.accordionTab.style.height = this.accordionTab.style.overflow = '';
	}


	closeOthers() {

		const openTabs = Array.from(document.querySelectorAll('accordion-tab details[open]'));

		openTabs.map(el => {

			// Don't close CURRENT EL of course
			if (el === this.accordionTab) return;

			el.style.overflow = 'hidden';

			const thisSummary = el.querySelector('summary')
			const endHeight = `${thisSummary.offsetHeight}px`;

			gsap.to(el, {
				height: endHeight,
				duration: 0.3,
				ease: 'Power2.inOut',
				onComplete: () => {
					el.open = false;
					el.style.height = el.style.overflow = '';
				}
			})

			if (el.querySelector("expand-icon")) el.querySelector("expand-icon").shrink()
		})
	}

}

class ExpandIcon extends HTMLElement {
	constructor(options) {
		// base for further abstraction if we want different
		// expansion icons which could be set via theme editor
		super();
		// right now its just set up for a plus that 
		// animates into a minus on expansion
		this.verticalLine = this.querySelector(".vertical")
	}
	expand(){
		gsap.to(this.verticalLine, {
			transformOrigin:"50% 50%",
			rotation: -90,
			opacity: 0.5,
			duration: 0.3,
			ease: "Power2.inOut",
		})
	}
	shrink(){
		gsap.to(this.verticalLine, {
			transformOrigin:"50% 50%",
			rotation: 0,
			opacity: 1,
			duration: 0.3,
			ease: "Power2.inOut",
		})
	}
}

export { ExpandIcon }